import React from 'react';
import {
  IPieceTypesState,
  ISteelTypesState
} from '../../../../../store/ducks/fabrication/types';
import { TableMenu } from '@gerdau/hefesto-mais-web';
import { Button, Icon } from '@gerdau/hefesto';
import { ExtraItensContentBlock } from '../styles';
import { AddItensButtonContainer } from './styles';
import ExtraItemTable from './ExtraItem/indexExtraItem';
import {
  DEFAULT_EXTRA_ITEM,
  IExtraItensState,
  IFabricationOrderExtraItem
} from '../../../../../store/ducks/fabrication-purchase-order/types';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { useDispatch } from 'react-redux';
interface IExtraItensContainerProps {
  pieceTypesState: IPieceTypesState | undefined;
  steelTypesState: ISteelTypesState | undefined;
  extraItensState: IExtraItensState;
  setExtraItensState(extraItensState: IExtraItensState): void;
}

const ExtraItensContainer: React.FC<IExtraItensContainerProps> = ({
  pieceTypesState,
  steelTypesState,
  extraItensState,
  setExtraItensState
}) => {
  const { screenName, itemDescription } = getTaggingInformationScreen(
    'extra_itens_add_item_annealed_steel'
  );
  const dispatch = useDispatch();

  const onClickAddItem = () => {
    setExtraItensState({
      ...extraItensState,
      otherPieces: [...extraItensState.otherPieces, DEFAULT_EXTRA_ITEM]
    });
    dispatch(
      sendTagging({
        screenName,
        itemName: 'button:adicionar_item',
        event: 'click',
        itemDescription: `${itemDescription}_pecasAdicionarItem`
      })
    );
  };

  const onRemoveExtraItemClick = (idx: number) => {
    if (extraItensState.otherPieces.length > 1) {
      const updatedItens = [...extraItensState.otherPieces];

      updatedItens.splice(idx, 1);
      setExtraItensState({
        ...extraItensState,
        otherPieces: updatedItens
      });
    } else {
      setExtraItensState({
        ...extraItensState,
        otherPieces: [DEFAULT_EXTRA_ITEM]
      });
    }
  };

  const onUpdateExtraItem = (updatedExtraItem: IFabricationOrderExtraItem) => {
    const updatedData = extraItensState.otherPieces.map((ex, index) =>
      index == updatedExtraItem.key ? updatedExtraItem : ex
    );

    setExtraItensState({
      ...extraItensState,
      otherPieces: updatedData
    });
  };

  return (
    <>
      <ExtraItensContentBlock>
        <AddItensButtonContainer>
          <TableMenu
            leftComponents={<></>}
            rightComponents={
              <span>
                <Button
                  name="addButton"
                  type="button"
                  variant="secondary"
                  onClick={onClickAddItem}
                  icon={<Icon option="Plus" />}
                >
                  Adicionar item
                </Button>
              </span>
            }
          />
        </AddItensButtonContainer>

        <ExtraItemTable
          extraItens={extraItensState.otherPieces}
          updateItemState={onUpdateExtraItem}
          pieceTypesState={pieceTypesState}
          steelTypesState={steelTypesState}
          onRemoveItem={onRemoveExtraItemClick}
          isTheOnlyItem={extraItensState.otherPieces.length === 1}
        />
      </ExtraItensContentBlock>
    </>
  );
};

export default ExtraItensContainer;
